var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_vm._v(" "),_c('breadcrumb',{attrs:{"secondhref":_vm.secondhref,"secondtest":_vm.secondtest}}),_vm._v(" "),_c('div',{staticClass:"content-body body-box",staticStyle:{"min-height":"420px","background-color":"#f5f5f5"}},[_c('choice-apply')],1),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99a8b9e2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apply.vue
// module id = null
// module chunks = 